import { useContext, useEffect, useState } from "react";
import FileDetails from "../components/dashboard/file-details";
import ServiceSlider from "../components/dashboard/service-slider";
import moment from "moment-jalaali";
import FileApi from "../api/file";
import AuthContext from "../components/auth-context";
import PortApi from "../api/port";
import Row from "../components/tailwind/row";

export default function Dashboard() {
  const [activeFile, setActiveFile] = useState(null);
  const [portState, setPortState] = useState(null);
  const [loadingService, setLoadingService] = useState(false);
  const [isNgnService, setNgnService] = useState(false);
  const [fileLoading, setFileLoading] = useState(false);
  const context = useContext(AuthContext);
  const { activeFileId } = context;

  useEffect(() => {
    if (!activeFileId) return;

    setFileLoading(true);

    new FileApi(context)
      .get(activeFileId)
      .then((data) => {
        setActiveFile(data);
        setNgnService(false);
        context.setServiceType(data.fileMedium);
        context.setCommands(data.commands);
        setLoadingService(false);
        if (data.fileMedium === 40) {
          setNgnService(true);
        }
      })
      .catch((error) => console.error("fileApi", error))
      .finally(() => setFileLoading(false));

    new PortApi(context)
      .get(activeFileId)
      .then((data) => {
        let state = null;
        switch (data.portState) {
          case 2:
          case 3:
            state = "down";
            break;
          case 1:
            state = "up";
            break;
          default:
            state = null;
        }
        setPortState(state);
      })
      .catch((error) => setPortState(null));
    // eslint-disable-next-line
  }, [activeFileId]);

  const lastService = { endDate: null, startDate: null };

  if (activeFile?.activeService) {
    lastService.startDate = moment(activeFile.activeService.startDateTime);
    lastService.endDate = moment(activeFile.activeService.endDateTime);
  }

  const hasNoRemindTraffic = activeFile?.constraints?.every(
    (c) => c.remind < 0
  );

  const handleActivateNextService = () => {
    const fileApi = new FileApi(context);
    fileApi.terminateCurrentService(activeFileId).then(({ errorMessage }) => {
      if (!errorMessage) {
        setLoadingService(true);
      }
    });
  };

  const remindDays = lastService.endDate?.diff(moment(), "days");

  if (fileLoading) {
    return (
      <div className="text-center w-100 py-5">
        <div className="w-16 h-16 border-4 border-solid border-gray-300 border-t-4 border-t-transparent rounded-full animate-spin mx-auto"></div>
        <p className="mt-3">در حال بارگذاری ...</p>
      </div>
    );
  }

  return activeFile?.title ? (
    <Row>
      {remindDays > 0 && (
        <ServiceSlider
          timeOfService={{
            total: lastService.endDate.diff(lastService.startDate, "days"),
            remind: lastService.endDate.diff(moment(), "days"),
          }}
          constraints={activeFile?.constraints}
          isNgnService={isNgnService}
        />
      )}
      <FileDetails
        activeService={
          loadingService
            ? {
                ...activeFile.activeService,
                serviceTitle: "در حال عملیات...",
              }
            : activeFile.activeService
        }
        preOrderedServiceTitle={
          loadingService ? "" : activeFile.preOrderedServiceTitle
        }
        hasNoRemindTraffic={hasNoRemindTraffic}
        status={activeFile.status}
        onActivateNextService={handleActivateNextService}
        link={portState}
      />
    </Row>
  ) : null;
}
